import React, {Component, PureComponent} from 'react';
import * as ReactDOM from 'react-dom';
import imLoading from "../../iconfont/loading/imLoading.gif";
import {
    Button,
    Checkbox,
    Divider,
    Dropdown,
    Empty,
    Image,
    Input,
    List,
    Menu,
    Popover,
    Select,
    Skeleton,
    Space, Tag
} from "antd";
import sendFail from "../../iconfont/loading/sendFail.png";
import SingleMsg from "../singleMsg/SingleMsg";
import RightClick from "../rightclick/rightclick";
import blue_arrow from "../../image/arrow/blue_arrow.png";
import white_arrow from "../../image/arrow/white_arrow.png";
import wxappLink from "../../image/messageList/wxappLink.png";
import red_arrow from "../../image/arrow/red_arrow.jpg";
import redBag from "../../image/messageList/redBag.jpg";
import Util from "../../../public/utils";
import videoHao from "../../image/messageList/videoHao.png";
import msgRecord from "../../image/messageList/msgRecord.png";
import ZkModal from "../../../common/modal/zkModal";
import ZkFormItem from "../../../common/form/zkFormItem";
import modal_warning from "../../../cloud/image/customer/groupsend/modal_warning.png";
import CloudApi from "../../../cloud/cloud_api";
import {Item, Submenu} from "react-contexify";
import mixMessage from "../../../public/mixedMessageParser";
import {page1, page2, page3, page4} from "../emoji/emoji";
import Message from "../../../common/message";
import ImForward from "../forward/forward";
import TextWithImg from "../singleMsg/TextWithImg";
import IconForward from "../../iconfont/forwardMsg/forward";
import IconClose from "../../iconfont/forwardMsg/close";
import PubSub from "pubsub-js";
import AvatarInfo from "../avatarInfo/avatarInfo";

let timer = null;
const {TextArea} = Input;
const {Option} = Select;
let token = null;
let mqTimer = null;

class MessageListClass extends PureComponent {

    mq = [];  //发送中的消息列表

    constructor(props) {
        super(props);
        this.state = {
            msgList: [],
            pages: 1,
            pageNum: 1,
            height: 0,
            fileObj: [],//文件url数组
            audioLoading: {id: '', loading: false}, //语音loadiong对象

            //转发
            testList: [],//转发列表
            total: 0,//分页总数
            defaultCurrent: 1,//默认分页
            transValue: '',//输入框的值

            msgId: [],//msgId
            modalLoading: false,
            radioDisabled: false,//转发 禁用开关

            delData: [],//踢出的对象
            delLoading: false,//踢出loading
            blackLoading: false,//踢出并拉黑loading

            addUserInfo: {},//个人信息
            userInfoInList: {},//个人信息
            addInfo: '',//要发送的验证信息

            isOver: false, //懒加载 loading

            isForward: false,
            selecting: false,

            materialData: [],
            materialList: [], //素材库分组列表
            materialId: '',
            matrialTitle: '',

            //名片加好友信息
            cardInfo: {
                wxwUserId: '', //企微号ID
                presenterId: '', //推荐人ID
                wxUserId: '', //名片消息中的shared_id字段
                chat_wxid: '', //聊天对象
            },

            //群聊加好友的 senderId
            senderId: '',
            addFriendLoading: false,

            //点击头像的个人信息
            content: '',
            //右键头像菜单dom
            overlay: '',

            //客户资料设置
            customerRemark: '',
            customerDesc: '',
            mobile: [],
            chat_wxid_in_room: '',
            setInfoLoading: false,
            customerAllTag: [],
            tagName: '',
        }
    }

    componentDidMount() {
        //定时器轮询 mq
        mqTimer = setTimeout(this.zkMsgTimeoutCallback, 1000)

        //PubSub订阅添加联系人
        token = PubSub.subscribe('IM_CHAT_ADD_FRIEND', (msg, data) => {
            this.addFriendFromRoomModal(data)
        });
    }

    componentWillUnmount() {
        clearTimeout(mqTimer)
        clearTimeout(timer)
        PubSub.unsubscribe(token);
    }

    componentWillReceiveProps(nextProps, nextContext) {
        const {wxid, chat_wxid, chatData} = this.props
        let propsStr = wxid + chat_wxid + JSON.stringify(chatData);
        let nextPropsStr = nextProps.wxid + nextProps.chat_wxid + JSON.stringify(nextProps.chatData);
        if (propsStr != nextPropsStr) {
            this.getAddFriendInfo(nextProps)
            setTimeout(this.setImgAlt)
            this.copyFun('im-msg-copy');
            this.setState({
                pageNum: 1,
                isOver: false,
                selecting: false,
                msgId: []
            }, () => {
                this.getMsgList(nextProps)
            })
        }

    }

    //发消息超时的回调
    zkMsgTimeoutCallback = async () => {
        if (this.mq.length) {
            // console.log('9898this.mq', this.mq)
            let list = [];
            for (let item of this.mq) {
                if ((new Date() * 1 - item.msgTime) > 10 * 1000) {
                    const {wxid, chat_wxid} = this.props
                    let queryParam = {
                        wxid: wxid,
                        chatWxid: chat_wxid,
                        msgSendId: item.msgData.msgSendId
                    }
                    await this.getSendStatus(queryParam).then(data => {
                        let index = this.mq.findIndex(item => item.msgData.msgSendId == queryParam.msgSendId)
                        list.push(index)
                        if (data.status == 0) {
                            item.loading = undefined
                            item.send_fail = true
                            this.acceptMsg(item)
                        } else {
                            item.loading = undefined
                            item.send_fail = false
                            this.acceptMsg(item)
                        }
                    })
                }
            }
            list.forEach(index => {
                if (index > -1) {
                    this.mq.splice(index, 1)
                }
            })
        }
        setTimeout(this.zkMsgTimeoutCallback, 1000)
    }

    getSendStatus = (queryParam) => {
        return new Promise(resolve => {
            //获取聚合聊天消息发送状态
            CloudApi.getImChatMsgSendStatus(queryParam, data => {
                //0：失败，1：成功
                resolve(data)
            })
        })
    }

    //重发消息回调
    changeLoading = (obj) => {
        //将消息的发送时间设置为当前, 并更改loading， 再执行父组件的 重发请求
        obj.msgTime = new Date() * 1
        let msg = JSON.parse(JSON.stringify(this.state.msgList))
        msg.forEach((item, index) => {
            if (obj.msgData.msgSendId == item.msgData.msgSendId) {
                item.send_fail = undefined
                item.loading = true
            }
        })
        this.setState({
            msgList: msg
        })
        //将mq 中对应的消息 改变状态, 发送时间设置为当前
        for (let item of this.mq) {
            if (item.msgData.msgSendId == obj.msgData.msgSendId) {
                item.send_fail = undefined
                item.loading = true
                item.msgTime = new Date() * 1
            }
        }
        this.props.reSend(obj)
    }

    //自己发送时，追加消息，  MD5id, 发送的类型msgType 发送的文本内容content，文件对象fileData, 解析完毕的混合消息对象mixContents
    addSelfMsg = (id, msgType, content, fileData, mixContents) => {
        const {msgList} = this.state
        const {chat_wxid, wxid} = this.props
        let msg = {
            msgData: {
                mixContents: mixContents, //混合消息的字段
                content: content,
                msgSendId: id,
                // content_back: "MTExMQ==",
                conversation_id: chat_wxid,
                file_name: fileData ? fileData.fileName : '',
                file_size: fileData ? fileData.file_size : '',
                file_contents: fileData ? fileData.file_contents : '',//发送文件是的socket数据
                url: fileData ? fileData.address : '', //链接 url
                title: fileData ? fileData.title : '', //链接 title
                des: fileData ? fileData.content : '',//链接 content
                thumburl: fileData ? fileData.url : '',//链接 图片
            },
            loading: true,
            send_fail: undefined,
            msgType: msgType,
            currentUrl: fileData ? fileData.currentUrl : '',
            senderId: wxid,
            senderName: '',
            sendAvator: '',
            corpShortName: '',
            msgTime: new Date() * 1,
        }
        this.setState({
            msgList: [...msgList, msg]
        })
        let test = JSON.parse(JSON.stringify(msg))
        this.mq.push(test)
    }

    //接受新消息
    acceptMsg = (newMsg, type) => {
        // console.log('9898newMsg', newMsg)
        const {msgList} = this.state
        const {chat_wxid} = this.props
        let currentMsg = JSON.parse(JSON.stringify(msgList))
        let pMsg = JSON.parse(JSON.stringify(newMsg))
        if (pMsg.msgData.conversation_id.indexOf(chat_wxid) != -1) {

            if (type && type == 'socket') {
                let index = this.mq.findIndex(item => item.msgData.msgSendId == newMsg.msgData.msgSendId)
                if (index != -1) {
                    this.mq.splice(index, 1)
                }
            }

            if (pMsg.msgType == 10001) {
                //撤回
                let arr = currentMsg.filter((item, index) => item.msgData.msg_unique_identifier != pMsg.msgData.msg_unique_identifier)
                arr.push(pMsg)
                this.setState({
                    msgList: arr
                })
            } else {
                //追加
                if (pMsg.msgType == 2 || pMsg.msgType == 0) {
                    let res = mixMessage.getEmojiText(pMsg.msgData.content)
                    if (res.length > 0) {
                        res.forEach(text => {
                            //4页表情
                            [...page1, ...page2, ...page3, ...page4].forEach(emoji => {
                                if (text == emoji.text) {
                                    //将表情文本替换成 html
                                    let html = `<img class="zkEmoji" alt="${text.replace(/\[|]/g, '')}" src="${emoji.url}"/>`
                                    let reg = '\\[' + text.substring(1, text.length - 1) + '\\]';
                                    pMsg.msgData.content = pMsg.msgData.content.replace(new RegExp(reg, 'gm'), html)
                                }
                            })
                        })
                    }
                }

                //遍历原来消息列表，更改 loading
                let count = 0 //标志位，如果是自己发的，更改loading， 不追加到列表
                currentMsg.forEach((item, index) => {
                    if (item.msgData.msgSendId != undefined && item.msgData.msgSendId == pMsg.msgData.msgSendId) {
                        item.msgData.msg_unique_identifier = pMsg.msgData.msg_unique_identifier
                        item.msgData.timestamp = pMsg.msgData.timestamp
                        count += 1
                        item.loading = undefined
                        if (pMsg.send_fail) {
                            item.send_fail = true;
                        }
                        // currentMsg[index] = pMsg
                    }
                })
                if (count == 0) {
                    currentMsg.push(pMsg)
                }
                // console.log('9898currentMsg', currentMsg)
                this.setState({
                    msgList: currentMsg
                })
                //给表情的alt属性 加上[]
                setTimeout(this.setImgAlt)
            }
            this.updateScroll(500)
        }
    }

    setImgAlt = () => {
        let emojoList = document.querySelectorAll('.zkEmoji')
        // console.log('9898', emojoList)
        emojoList.forEach(item => {
            if (!item.alt.includes('[')) {
                item.setAttribute('alt', `[${item.alt}]`)
            }
        })
    }

    //复制
    copyFun = (id) => {
        let clipboard = new ClipboardJS('#' + id);
        clipboard.on('success', function (e) {
            // Message.success("复制成功！");
            e.clearSelection();
        });
        clipboard.on('error', function (e) {
            // alert('请选择“拷贝”进行复制!')
        });
    }

    //滚动到顶部继续加载
    handleScroll = () => {
        const {pageNum, pages} = this.state
        let scroll = document.getElementById('im-words');
        let clientHeight = scroll.clientHeight  // 可视区域
        let scrollTop = scroll.scrollTop  //当前位置 最上面0
        let scrollHeight = scroll.scrollHeight //总高
        // console.log('777scrollTop', clientHeight, scrollHeight, scrollTop)

        // return
        //滚到顶部 继续加载, 此处防抖处理，高频触发，一定周期内仅执行一次
        clearTimeout(timer)
        if (scroll.scrollTop < 30 && pageNum < pages && clientHeight != scrollHeight) {
            timer = setTimeout(() => {
                //在元素塞进去之前  获取 height =  元素.scrollHeight - 元素.scrollTop  就是获取与底部的距离
                let height = scrollHeight - scrollTop //与底部的距离
                this.setState({
                    pageNum: pageNum + 1,
                    height: height
                }, () => {
                    this.getNextList(pageNum)
                })
            }, 500)
        }

    }

    //更新滚动条
    updateScroll = (time) => {
        let oWords = document.getElementById('im-words');
        if (oWords) {
            setTimeout(() => {
                oWords.scrollTop = oWords.scrollHeight
            }, time || 0)
        }
    }

    getNextList = () => {
        this.setState({
            isOver: false,
        })
        const {pageNum, msgList, height} = this.state
        //id变化 请求 聊天内容接口
        let queryParam = {
            pageSize: 20,
            pageNum: pageNum,
        }
        const {wxid, chat_wxid, chatData} = this.props

        let bodyData = {
            wxid: wxid,
            chat_wxid: chat_wxid,
        }
        CloudApi.getChatMsgs(queryParam, bodyData, data => {
            //如果有头图，该头图是 私聊的对方头图
            if (chatData && chatData.isRoom == 0 && chatData.avatar) {
                data.list.forEach(item => {
                    item.sendAvator = chatData.avatar
                })
            }
            //表情转换
            data.list.forEach((item) => {
                if (item.msgType == 2 || item.msgType == 0) {
                    let res = mixMessage.getEmojiText(item.msgData.content)
                    if (res.length > 0) {
                        res.forEach(text => {
                            //4页表情
                            [...page1, ...page2, ...page3, ...page4].forEach(emoji => {
                                if (text == emoji.text) {
                                    //将表情文本替换成 html
                                    let html = `<img class="zkEmoji" alt="${text.replace(/\[|]/g, '')}" src="${emoji.url}"/>`
                                    let reg = '\\[' + text.substring(1, text.length - 1) + '\\]';
                                    item.msgData.content = item.msgData.content.replace(new RegExp(reg, 'gm'), html)
                                }
                            })
                        })
                    }
                }
            })

            if (chat_wxid == Util.getUrlArg('chat_wxid')) {
                this.setState({
                    msgList: [...data.list.reverse(), ...msgList]
                }, () => {
                    this.setImgAlt()
                    this.copyFun('im-msg-copy');

                    //在元素塞进去之后   元素.scrollTop = 元素.scrollHeight -  height (刚刚获取到的距离)
                    let scroll = document.getElementById('im-words');
                    scroll.scrollTop = scroll.scrollHeight - height - 40
                })
            }
            this.setState({
                isOver: true,
                pages: data.pagInfo.pages,
            })
        }, error => {
        })
    }

    getMsgList = (nextProps) => {
        this.setState({
            isOver: false,
            msgList: []
        })
        //id变化 请求 聊天内容接口
        let queryParam = {
            pageSize: 20,
            pageNum: 1,
        }
        const {wxid, chat_wxid, chatData} = this.props

        let bodyData = {
            wxid: nextProps ? nextProps.wxid : wxid,
            chat_wxid: nextProps ? nextProps.chat_wxid : chat_wxid,
        }
        CloudApi.getChatMsgs(queryParam, bodyData, data => {
            //如果有头图，该头图是 私聊的对方头图
            if (nextProps) {
                if (nextProps.chatData && nextProps.chatData.isRoom == 0 && nextProps.chatData.avatar) {
                    data.list.forEach(item => {
                        item.sendAvator = nextProps.chatData.avatar
                    })
                }
            } else {
                if (chatData && chatData.isRoom == 0 && chatData.avatar) {
                    data.list.forEach(item => {
                        item.sendAvator = chatData.avatar
                    })
                }
            }
            //表情转换
            data.list.forEach((item) => {
                if (item.msgType == 2 || item.msgType == 0) {
                    let res = mixMessage.getEmojiText(item.msgData.content)
                    if (res.length > 0) {
                        res.forEach(text => {
                            //4页表情
                            [...page1, ...page2, ...page3, ...page4].forEach(emoji => {
                                if (text == emoji.text) {
                                    //将表情文本替换成 html
                                    let html = `<img class="zkEmoji" alt="${text.replace(/\[|]/g, '')}" src="${emoji.url}"/>`
                                    let reg = '\\[' + text.substring(1, text.length - 1) + '\\]';
                                    item.msgData.content = item.msgData.content.replace(new RegExp(reg, 'gm'), html)
                                }
                            })
                        })
                    }
                }
            })

            if (nextProps ? nextProps.chat_wxid : chat_wxid == Util.getUrlArg('chat_wxid')) {
                this.setState({
                    msgList: data.list.reverse()
                }, () => {
                    this.setImgAlt()
                    this.copyFun('im-msg-copy');
                    setTimeout(() => this.updateScroll(), 500)
                })
            }
            this.setState({
                isOver: true,
                pages: data.pagInfo.pages,
            })
        }, error => {
        })
    }

    /**
     *  以下是转发 转发modal相关
     */

    openNewModal = (msg) => {
        // console.log('9898',msg)
        this.setState({
            msgId: [msg.msgData.msg_unique_identifier]
        })
        this.forwardModalRef.show()
    }

    //socket转发消息
    sendMore = () => {
        const {msgId} = this.state
        const {outSocket} = this.props
        let chatList = this.imForwardRef ? this.imForwardRef.exportData() : []
        let idArr = []
        idArr = chatList.map(item => item.id)
        let contents = [
            {
                msg_type: 5200,
                content: {
                    chatList: idArr,
                    msgIdList: msgId,
                }
            }
        ]
        outSocket(contents)
        this.forwardModalRef.hide()
        //取消勾选
        this.closeSelecting()
    }

    //转发回调
    getStatus = data => {
        this.setState({
            isForward: data.length
        })
    }

    //modol关闭后的回调
    afterClose = () => {
        this.setState({
            msgId: []
        })
    }

    //撤回消息
    retract = (msg) => {
        const {reCallSocket} = this.props
        let msgId = msg.msgData.msg_unique_identifier
        if ((new Date() * 1 / 1000 - msg.msgData.timestamp) > 2 * 60) {
            return Message.warning('超过两分钟无法撤回')
        }
        let contents = {
            msgId: msgId,
        }
        reCallSocket(contents)
    }

    //@群聊的某人
    remind = (obj) => {
        this.props.getOneRemind(obj)
    }

    delModal = (obj) => {
        // console.log('9898',obj)
        this.deleteModalRef.show()
        this.setState({
            delData: obj
        })
    }

    //群聊踢人
    delApi = () => {
        this.setState({
            delLoading: true
        })
        const {wxid, chat_wxid} = this.props
        const {delData} = this.state
        let bodyData = {
            wxid: wxid,
            chat_wxid: chat_wxid,
            customerIds: [delData.senderId]
        }
        CloudApi.getChatRemoveFromGroup(bodyData, (data) => {
            this.setState({
                delLoading: false
            })
            this.deleteModalRef.hide()
            Message.success('已踢出')
        }, () => {
            this.setState({
                delLoading: false
            })
            Message.error('踢人失败')
        })
    }

    //群聊踢人并拉黑
    delAndBlackApi = () => {
        this.setState({
            blackLoading: true
        })
        const {wxid, chat_wxid} = this.props
        const {delData} = this.state
        let bodyData = {
            wxid: wxid,
            chat_wxid: chat_wxid,
            customerIds: [delData.senderId],
            toBlacklist: 1, //"toBlacklist": "拉入黑名单，0：不拉入，1拉入"
        }
        CloudApi.getChatRemoveFromGroup(bodyData, (data) => {
            this.setState({
                blackLoading: false
            })
            this.deleteModalRef.hide()
            Message.success('已踢出并加入黑名单')
        }, () => {
            this.setState({
                blackLoading: false
            })
            Message.error('踢人并加入黑名单失败')
        })
    }

    // {发送好友请求 onchange}
    addUserChange = (e) => {
        let value = e.target.value
        this.setState({
            addInfo: value
        })
    }

    addFriendModal = () => {
        const {corpShortName, nickname} = this.state.addUserInfo
        //设置默认的个人信息
        if (corpShortName == '微信' || corpShortName == undefined) {
            this.setState({
                addInfo: `我是${nickname}，添加我的微信与联系人吧。`
            })
        } else {
            this.setState({
                addInfo: `我是${corpShortName}的${nickname}，添加我的企业微信与联系人吧。`
            })
        }
        this.addUserRef.show()
    }

    //个人信息
    getAddFriendInfo = (nextProps) => {
        let wxid = '';
        let chat_wxid = '';
        if (nextProps) {
            wxid = nextProps.wxid
            chat_wxid = nextProps.chat_wxid
        } else {
            wxid = this.props.wxid
            chat_wxid = this.props.chat_wxid
        }
        CloudApi.getChatAddFriendInfo(wxid, data => {
            this.setState({
                addUserInfo: data
            })
        })
        CloudApi.getChatAddFriendInfo(chat_wxid, data => {
            this.setState({
                userInfoInList: data
            })
        })
    }

    addFriendApi = () => {
        const {wxid, chat_wxid} = this.props
        const {addInfo} = this.state
        let bodyData = {
            wxid: wxid,
            chat_wxid: chat_wxid,
            verifyInfo: addInfo,
        }
        this.addUserRef.hide()
        CloudApi.addChatFriend(bodyData, data => {
            Message.success('请求已发送！')
        }, error => {
        })
    }

    //语音转文字接口
    audioToText = (obj) => {
        this.setState({
            audioLoading: {id: obj.msgData.msg_unique_identifier, loading: true}
        })
        const {msgList} = this.state
        const {wxid} = this.props
        let bodyData = {
            msgId: obj.msgData.msg_unique_identifier,
            wxid: wxid,
        }
        CloudApi.chatAudioToListen(bodyData, data => {
        })
        let msg = JSON.parse(JSON.stringify(msgList))
        CloudApi.chatAudioToText(bodyData, data => {
            msg.forEach((item, index) => {
                if (item.msgData.msg_unique_identifier == obj.msgData.msg_unique_identifier) {
                    item.translatedInfo = data.translatedInfo || '无内容'
                    item.audioHasListen = 1
                }
            })
            this.setState({
                audioLoading: {id: obj.msgData.msg_unique_identifier, loading: false},
                msgList: msg
            })
        }, error => {
            this.setState({
                audioLoading: {id: obj.msgData.msg_unique_identifier, loading: false}
            })
        })
    }

    getBlob = (url) => { // url:是文件在oss上的地址
        return new Promise(resolve => {
            const xhr = new XMLHttpRequest();
            xhr.open("GET", url, true);
            xhr.responseType = "blob";// 请求类型是blob类型
            xhr.crossOrigin = "*"; // 解决跨域问题
            xhr.onload = () => {
                if (xhr.status === 200) {
                    resolve(xhr.response);
                }
            };
            xhr.send();
        });
    };

    saveAs = (blob, filename) => {
        const link = document.createElement("a");
        const body = document.querySelector("body");
        const myBlob = new Blob([blob])
        link.href = window.URL.createObjectURL(myBlob);
        link.download = filename; //修改文件名
        link.style.display = "none";
        body.appendChild(link);
        link.click();
        body.removeChild(link);
    }

    getFileUrlList = (obj) => {
        let list = this.state.fileObj
        list[obj.index] = obj.url
        this.setState({
            fileObj: list
        })
    }

    copyImg = (imgSrc) => {
        this.getBlob(imgSrc).then(res => {
            const clipboardItem = new ClipboardItem({[res.type]: res})
            navigator.clipboard.write([clipboardItem]);
        });
    };

    subImgName = (str) => {
        let index = str.lastIndexOf('/')
        let imgName = str.substring(index + 1)
        //不带后缀的 添加 。jpg 后缀
        if (imgName.indexOf('.') == -1) {
            imgName = imgName + '.jpg'
        }
        return imgName
    }

    selectingMsg = () => {
        const {selecting} = this.state
        this.setState({
            selecting: true
        })
    }

    closeSelecting = () => {
        this.setState({
            selecting: false,
            msgId: []
        })
    }

    selectingDOM = () => {
        const {msgId} = this.state
        return (
            <div className={'zk-selecting-edit-dom'}>
                <div className={`zk-selecting-edit-earch ${msgId.length ? '' : 'disabled'}`}
                     onClick={() => this.forwardModalRef.show()}>
                    <div className={'zk-selecting-edit-bg'}><IconForward/></div>
                    <div>逐条转发</div>
                </div>
                <div className={'zk-selecting-edit-earch'} onClick={this.closeSelecting}>
                    <div className={'zk-selecting-edit-bg'}><IconClose/></div>
                    <div>取消</div>
                </div>
            </div>
        )
    }

    msgChecked = (e, item) => {
        let checked = e.target.checked
        let id = item.msgData.msg_unique_identifier
        let arr = [...this.state.msgId]
        //选中push该条，取消选中删除该条
        if (checked) {
            arr.push(id)
        } else {
            let index = arr.findIndex(item => item == id)
            arr.splice(index, 1)
        }
        this.setState({
            msgId: arr
        })
    }

    //素材库下拉分组接口
    getMaterialList = () => {
        CloudApi.getCustomerMediaGroupsList(data => {
            this.setState({
                materialList: data.list
            })
        }, error => {
            Message.error('素材库分组列表请求超时，请稍后重试')
        })
    }

    //打开素材库分组modal
    openMaterialModal = (item) => {
        this.setState({
            materialData: item
        })
        this.materialRef.show()
        this.getMaterialList()
    }

    //消息添加到素材库接口
    doAddMaterialApi = () => {
        const {materialData, materialId, matrialTitle} = this.state
        const {wxid} = this.props
        let bodyData = {
            name: matrialTitle,
            groupId: materialId,
            msgId: materialData.msgId,
            wxId: wxid
        }
        CloudApi.addImChatMsgToLib(bodyData, () => {
            this.materialRef.hide()
            Message.success('已添加到素材库')
        }, error => {
            Message.error(error.description)
        })
    }

    //名片加好友modal
    addFriendFromCardModal = (obj) => {
        const {corpShortName, nickname} = this.state.addUserInfo
        const {wxid, chat_wxid} = this.props
        const {sender_id, shared_id} = obj.msgData
        //设置默认的个人信息
        if (corpShortName == '微信' || corpShortName == undefined) {
            this.setState({
                addInfo: `我是${nickname}，添加我的微信与联系人吧。`
            })
        } else {
            this.setState({
                addInfo: `我是${corpShortName}的${nickname}，添加我的企业微信与联系人吧。`
            })
        }
        this.setState({
            cardInfo: {
                wxwUserId: wxid, //企微号ID
                presenterId: sender_id, //推荐人ID
                wxUserId: shared_id, //名片消息中的shared_id字段
                chat_wxid: chat_wxid, //聊天对象
            }
        })
        this.friendCardRef.show()
    }

    //名片加好友接口
    doAddFriendFromCardApi = () => {
        const {cardInfo} = this.state
        const {addInfo} = this.state
        let bodyData = {
            ...cardInfo,
            verifyText: addInfo, //验证信息
        }
        CloudApi.addFriendFromCard(bodyData, data => {
            this.friendCardRef.hide()
            Message.success('好友请求已发送！')
        }, error => {
            Message.success('好友请求发送失败， 请稍后重试！')
        })
    }

    //群聊加好友
    addFriendFromRoomModal = (obj) => {
        //先请求接口检查是否已经是好友
        const {wxid} = this.props
        const {senderId} = obj
        const {corpShortName, nickname} = this.state.addUserInfo
        //设置默认的个人信息
        this.setState({
            addInfo: `我是${nickname}，添加我的企业微信与联系人吧。`
        })
        let bodyData = {
            wxid: wxid,
            chat_wxid: senderId,
        }
        CloudApi.isFriendFromRoom(bodyData, data => {
            //1:已经是好友  0:发送成功
            if (data.status === 1) {
                this.alreadyBeFriendRef.show()
            } else {
                this.setState({
                    senderId: senderId
                })
                this.friendRoomRef.show()
            }
        }, error => {
            Message.error('请求超时，请稍后重试！')
        })
    }

    doAddFriendFromRoomApi = () => {
        this.setState({
            addFriendLoading: true
        })
        const {wxid, chat_wxid} = this.props
        const {addInfo, senderId} = this.state
        let bodyData = {
            wxid: wxid,
            memberId: senderId,
            roomId: chat_wxid,
            verifyInfo: addInfo,
        }
        CloudApi.addFriendFromRoom(bodyData, data => {
            this.setState({
                addFriendLoading: false
            })
            this.friendRoomRef.hide()
            Message.success('好友请求已发送！')
        }, error => {
            this.setState({
                addFriendLoading: false
            })
            Message.error('好友请求发送失败， 请稍后重试！')
        })
    }

    //系统消息display值
    getDisplayValue = (item) => {
        // style={{display: [10001, 150024, 150026, 150027].indexOf(item.msgType) != -1 ? 'none' : ''}}
        if ([10001, 150024, 150026, 150027].indexOf(item.msgType) != -1) {
            return 'none'
        } else {
            return ''
        }
    }

    //右键菜单
    getItems = (item, index) => {
        const {getQuote, wxid} = this.props
        const {fileObj} = this.state
        {/**
         * //2 0文本  14 101图片 23 103视频 15 102文件 13链接 16语音 78小程序  141视频号 26红包
         */
        }
        return (
            <>
                {
                    item.msgType == 15 || item.msgType == 102 || item.msgType == 23 || item.msgType == 103 ?
                        <Item onClick={() => {
                            this.getBlob(fileObj[index]).then(res => {
                                this.saveAs(res, item.msgData.file_name)
                            })
                        }}>下载</Item> : ''
                }
                {
                    item.msgType == 2 || item.msgType == 0 ?
                        <Item id="im-msg-copy"
                              data-clipboard-target={`#im-msg-copy-value${index}`}
                              data-clipboard-action="copy">复制
                        </Item> : ''
                }
                {
                    item.msgType == 14 || item.msgType == 101 ?
                        <>
                            <Item id={`im-copy-img${index}`}
                                  onClick={() => {
                                      // console.log('9898', fileObj[index])
                                      let str = (item.msgType == 14 || item.msgType == 101) ? '?x-oss-process=style/chatdownload' : ''
                                      this.copyImg(fileObj[index] + str)
                                  }}
                            >复制</Item>
                            <Item onClick={() => {
                                this.getBlob(fileObj[index]).then(res => {
                                    this.saveAs(res, this.subImgName(fileObj[index]))
                                })
                            }}>下载</Item>
                        </> : ''
                }
                {
                    item.msgType == 16 && item.translatedInfo === undefined ?
                        <Item onClick={() => this.audioToText(item)}>转文字</Item> : ''
                }
                {
                    item.msgType == 2 || item.msgType == 0 ?
                        <Item onClick={() => getQuote(item)}>引用</Item> : ''
                }
                {
                    //名片 和 红包 不能多选 和转发
                    item.msgType != 26 && item.msgType != 41 ?
                        <>
                            <Item onClick={() => {
                                // this.openModal(item)
                                this.openNewModal(item)
                            }}>转发</Item>
                            <Item onClick={this.selectingMsg}>多选</Item>
                        </>
                        : ''
                }
                {
                    item.senderId == wxid && (item.msgType == 2 || item.msgType == 0 || item.msgType == 14 || item.msgType == 13) && ((new Date() * 1 / 1000 - item.msgData.timestamp) < 2 * 60) ?
                        <Item onClick={() => this.retract(item)}>撤回</Item> : ''
                }
                {
                    //群聊 @ 和 踢人  是群聊， 并且不是自己 才有踢人和艾特
                    item.senderName && item.senderId != wxid ?
                        <>
                            {/*<div className={'room-other-edit'}></div>*/}
                            {/*<Item onClick={() => this.remind(item)}>{'@TA'}</Item>*/}
                            <Item onClick={() => this.delModal(item)}>{'踢走'}</Item>
                        </> : ''
                }
                {
                    //41 好友名片  不在群聊
                    item.msgType == 41 ?
                        <>
                            <Item onClick={() => this.addFriendFromCardModal(item)}>添加好友</Item>
                        </>
                        : ''
                }
                {
                    //群聊 @ 和 踢人  是群聊， 并且不是自己
                    item.senderName && item.senderId != wxid && item.msgType != 41 ?
                        <>
                            {/*<Item onClick={() => this.addFriendFromRoomModal(item)}>{'添加对方好友'}</Item>*/}
                        </> : ''
                }
                {
                    //2 0文本  14 101图片 23 103视频 15 102文件 13链接 16语音 78小程序  141视频号
                    [0, 2, 14, 101, 23, 103, 15, 102, 13, 16, 78, 141].indexOf(item.msgType) != -1 ?
                        <>
                            {/*<div className={'room-other-edit'}></div>*/}
                            <Item onClick={() => this.openMaterialModal(item)}>添加到素材库</Item>
                        </> : ''
                }
            </>
        )
    }

    //右键头像菜单显示隐藏的回调
    onVisibleChangeForDropdown = (value, item) => {
        if (value) {

            this.setState({
                overlay: (
                    <Menu>
                        <Menu.Item><Skeleton paragraph={{rows: 1, width: ['80px']}} title={''}/></Menu.Item>
                        <Menu.Item><Skeleton paragraph={{rows: 1, width: ['80px']}} title={''}/></Menu.Item>
                    </Menu>
                )
            })
            //请求接口检查是否已经是好友
            const {wxid} = this.props
            const {senderId} = item
            let bodyData = {
                wxid: wxid,
                chat_wxid: senderId,
            }
            CloudApi.isFriendFromRoom(bodyData, data => {
                // 1:已经是好友  0:不是好友
                let overlayDom = (
                    <Menu>
                        {
                            data.status == 1 ?
                                <Menu.Item onClick={() => {
                                    PubSub.publish('IM_CHAT_SEND_MESSAGE', {chat_wxid: senderId});
                                }}>{'发送消息'}</Menu.Item> :
                                <Menu.Item onClick={() => this.addFriendFromRoomModal(item)}>{'添加为联系人'}</Menu.Item>
                        }
                        <Menu.Item className={'zk-avatar-menue'}
                                   onClick={() => this.remind(item)}>{`@${item.msgData.sender_nickname}`}</Menu.Item>
                    </Menu>
                )
                this.setState({
                    overlay: overlayDom
                })
            })
        }
    }

    render() {
        const {
            msgList, pageNum, audioLoading, isOver, addUserInfo, userInfoInList,
            addInfo, delLoading, blackLoading, delData, pages, isForward,
            selecting, materialList, materialId, matrialTitle, addFriendLoading,
            overlay,
        } = this.state
        const {wxid, chat_wxid, chatDataSelf, chatData, getQuote, leftSelect} = this.props
        const element = document.getElementById('zk-chatroom-bottom-id')

        return (
            <>
                {
                    //Portal 提供了一种将子节点渲染到存在于父组件以外的 DOM 节点的优秀的方案。ReactDOM.createPortal(child, container)
                    // 第一个参数（child）是任何可渲染的 React 子元素，例如一个元素，字符串或 fragment。第二个参数（container）是一个 DOM 元素。
                    element && selecting ? ReactDOM.createPortal(
                        this.selectingDOM(),
                        element
                    ) : ''
                }
                <List
                    className="mes-max all_conversations"
                    id={'im-words'}
                    loading={pageNum == 1 && !isOver ? true : false}
                    itemLayout="horizontal"
                    onScroll={this.handleScroll}
                    // loadMore={loadMore}
                    dataSource={msgList}
                    renderItem={(item, index) => (
                        <List.Item
                            key={(item.msgData.msgSendId || item.msgData.msg_unique_identifier) + item.msgData.timestamp}>
                            <div className="mes-max all_conversations">
                                {
                                    index == 0 && !isOver ?
                                        <div className={'im-msg-loading'}>
                                            <img src={imLoading}/>
                                        </div> : ''
                                }
                                {
                                    index == 0 && isOver && pageNum == pages && pages > 1 ?
                                        <div className={'im-msg-noMore'}>没有更多了</div> : ''
                                }
                                {
                                    index > 0 ?
                                        msgList[index].msgTime - msgList[index - 1].msgTime > 120 * 1000 ?
                                            <div className={'message_time_blank'}>
                                                {new Date(msgList[index].msgTime).format('yyyy-MM-dd hh:mm:ss')}
                                            </div> : '' : ''
                                }
                                <div className={'message_item'}
                                     style={{justifyContent: item.senderId == wxid ? 'space-between' : 'flex-start'}}>
                                    {
                                        selecting && [10001, 150024, 150026, 150027].indexOf(item.msgType) == -1 ?
                                            <Checkbox
                                                style={{display: selecting ? 'inherit' : 'none'}}
                                                className={'zk-chat-check-style'}
                                                disabled={item.msgType == 26 || item.msgType == 41}
                                                onChange={e => this.msgChecked(e, item)}
                                            >
                                            </Checkbox> :
                                            <div>{/* 该空div不能删 ！！！ 为了space-between时占位用*/}</div>
                                    }
                                    {
                                        item.msgType == 10001 ?
                                            <div
                                                className={'im-system-msg'}>
                                                {item.senderId == wxid ? `你撤回了一条消息` : `“${item.msgData.sender_nickname}” 撤回了一条消息`}
                                            </div> : ''
                                    }
                                    {
                                        item.msgType == 150024 ?
                                            <div className={'im-system-msg im-system-box'}
                                                 style={{display: isOver ? '' : 'none'}}>
                                                <div className={'im-not-friend'}>
                                                    {`${userInfoInList.nickname}开启了联系人验证，你还不是他（她）的联系人。请先发送联系人验证请求，对方验证通过后，才能聊天。`}
                                                    <a onClick={this.addFriendModal}>{'发送联系人验证'}</a>
                                                </div>
                                            </div> : ''
                                    }
                                    {
                                        item.msgType == 150026 ?
                                            <div className={'im-system-msg im-system-box'}
                                                 style={{display: isOver ? '' : 'none'}}>
                                                <div className={'im-not-friend'}>
                                                    {item.msgData.system_msg_descrption}
                                                </div>
                                            </div> : ''
                                    }
                                    {
                                        item.msgType == 150027 ?
                                            <div className={'im-system-msg im-system-box'}
                                                 style={{display: isOver ? '' : 'none'}}>
                                                <div className={'im-not-friend'}>
                                                    {item.msgData.system_msg_descrption}
                                                </div>
                                            </div> : ''
                                    }
                                    {
                                        //是否自己
                                        item.senderId == wxid ?
                                            <>
                                                <div className={'message_content'}>
                                                    {
                                                        item.loading != undefined ?
                                                            <img src={imLoading}
                                                                 className={'self_loading'}/> : ''
                                                    }
                                                    {
                                                        item.send_fail ?
                                                            <img src={sendFail}
                                                                 className={'self_loading'}
                                                                 onClick={() => this.changeLoading(item)}/> : ''
                                                    }
                                                    <div className={'im-info'} style={{justifyContent: 'flex-end'}}>
                                                        <div className={'self-time-in-room'}>
                                                            {
                                                                item.msgType == 2 || item.msgType == 0 ?
                                                                    <SingleMsg item={item} pageNum={pageNum}>
                                                                        <RightClick menuId={"rightClick" + index}
                                                                                    item={this.getItems(item, index)}
                                                                        >
                                                                            <div className={'im-msg im-common'}
                                                                                 id={'im-msg-copy-value' + index}
                                                                            >
                                                                                <div
                                                                                    dangerouslySetInnerHTML={{__html: item.msgData.content}}/>
                                                                                <img src={blue_arrow}
                                                                                     className={'self_arrow'}/>
                                                                            </div>
                                                                        </RightClick>
                                                                    </SingleMsg> :
                                                                    item.msgType == 16 ?
                                                                        <RightClick
                                                                            menuId={"rightClick" + index}
                                                                            item={this.getItems(item, index)}
                                                                        >
                                                                            <div>
                                                                                <SingleMsg item={item} wxid={wxid}
                                                                                           updateScroll={this.updateScroll}
                                                                                           audioLoading={audioLoading}
                                                                                           pageNum={pageNum}>
                                                                                </SingleMsg>
                                                                            </div>
                                                                        </RightClick> :
                                                                        item.msgType == 14 || item.msgType == 101 ?
                                                                            <RightClick
                                                                                menuId={"rightClick" + index}
                                                                                item={this.getItems(item, index)}
                                                                            >
                                                                                <div>
                                                                                    <SingleMsg item={item}
                                                                                               wxid={wxid}
                                                                                               currentUrl={item.currentUrl}
                                                                                               updateScroll={this.updateScroll}
                                                                                               uploadFilesUrl={item.msgData.pictureUrl}
                                                                                               pageNum={pageNum}
                                                                                               getFileUrlList={this.getFileUrlList}
                                                                                               index={index}
                                                                                    >
                                                                                    </SingleMsg>
                                                                                </div>
                                                                            </RightClick> :
                                                                            item.msgType == 23 || item.msgType == 103 ?
                                                                                <RightClick
                                                                                    menuId={"rightClick" + index}
                                                                                    item={this.getItems(item, index)}
                                                                                >
                                                                                    <div>
                                                                                        <SingleMsg item={item}
                                                                                                   wxid={wxid}
                                                                                                   updateScroll={this.updateScroll}
                                                                                                   currentUrl={item.currentUrl}
                                                                                                   getFileUrlList={this.getFileUrlList}
                                                                                                   index={index}
                                                                                                   pageNum={pageNum}>
                                                                                        </SingleMsg>
                                                                                    </div>
                                                                                </RightClick> :
                                                                                item.msgType == 15 || item.msgType == 102 ?
                                                                                    <RightClick
                                                                                        menuId={"rightClick" + index}
                                                                                        item={this.getItems(item, index)}
                                                                                    >
                                                                                        <div>
                                                                                            <SingleMsg item={item}
                                                                                                       wxid={wxid}
                                                                                                       updateScroll={this.updateScroll}
                                                                                                       currentUrl={item.currentUrl}
                                                                                                       pageNum={pageNum}
                                                                                                       getFileUrlList={this.getFileUrlList}
                                                                                                       index={index}
                                                                                            >
                                                                                            </SingleMsg>
                                                                                        </div>
                                                                                    </RightClick> :
                                                                                    item.msgType == 41 ?
                                                                                        <SingleMsg item={item}
                                                                                                   wxid={wxid}
                                                                                                   getQuote={getQuote}
                                                                                                   openModal={this.openModal}
                                                                                                   pageNum={pageNum}
                                                                                        >
                                                                                            <RightClick
                                                                                                menuId={"rightClick" + index}
                                                                                                item={this.getItems(item, index)}
                                                                                            >
                                                                                                <div
                                                                                                    className={'im-common'}>
                                                                                                    <div
                                                                                                        className={'im-wxInfo'}>
                                                                                                        <img
                                                                                                            src={white_arrow}
                                                                                                            className={'self_arrow'}/>
                                                                                                        <div
                                                                                                            className={'wxInfo-header'}>
                                                                                                            <img
                                                                                                                src={item.msgData.headimg}/>
                                                                                                            <div>{item.msgData.nick}</div>
                                                                                                        </div>
                                                                                                        <div
                                                                                                            className={'wxInfo-line'}></div>
                                                                                                        <div
                                                                                                            className={'im-wxcard'}>{'个人名片'}</div>
                                                                                                    </div>
                                                                                                </div>
                                                                                            </RightClick>
                                                                                        </SingleMsg> :
                                                                                        item.msgType == 78 ?
                                                                                            <SingleMsg item={item}
                                                                                                       wxid={wxid}
                                                                                                       pageNum={pageNum}
                                                                                            >
                                                                                                <RightClick
                                                                                                    menuId={"rightClick" + index}
                                                                                                    item={this.getItems(item, index)}
                                                                                                >
                                                                                                    <div
                                                                                                        className={'im-common'}>
                                                                                                        <div
                                                                                                            className={'im-wxapp'}>
                                                                                                            <img
                                                                                                                src={white_arrow}
                                                                                                                className={'self_arrow_trans'}/>
                                                                                                            <div
                                                                                                                className={'wxapp-header'}>
                                                                                                                <img
                                                                                                                    src={item.msgData.headimg || item.msgData.thumburl}/>
                                                                                                                <div>{item.msgData.title}</div>
                                                                                                            </div>
                                                                                                            <span
                                                                                                                className={'wxapp-desc'}>{item.msgData.des || item.msgData.desc}
                                                                                                            </span>
                                                                                                            {/*<img*/}
                                                                                                            {/*    src={item.msgData.coverImgUrl || item.msgData.coverimgurl}*/}
                                                                                                            {/*    className={'wxapp-big-img'}/>*/}
                                                                                                            <div
                                                                                                                className={'wx-app-bg'}
                                                                                                                style={{backgroundImage: `url(${item.msgData.coverImgUrl || item.msgData.coverimgurl})`}}>
                                                                                                            </div>
                                                                                                            <div
                                                                                                                className={'wxInfo-line'}>
                                                                                                            </div>
                                                                                                            <div
                                                                                                                className={'wxapp-bottom'}>
                                                                                                                <img
                                                                                                                    src={wxappLink}/>
                                                                                                                <div
                                                                                                                    className={'im-wxcard'}>{'小程序'}
                                                                                                                </div>
                                                                                                            </div>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                </RightClick>
                                                                                            </SingleMsg> :
                                                                                            item.msgType == 13 ?
                                                                                                <SingleMsg
                                                                                                    item={item}
                                                                                                    wxid={wxid}
                                                                                                    pageNum={pageNum}
                                                                                                >
                                                                                                    <RightClick
                                                                                                        menuId={"rightClick" + index}
                                                                                                        item={this.getItems(item, index)}
                                                                                                    >
                                                                                                        <div
                                                                                                            className={'im-common'}>
                                                                                                            <a href={item.msgData.url}
                                                                                                               target={'_blank'}
                                                                                                               className={'im-msg-link'}>
                                                                                                                <img
                                                                                                                    src={white_arrow}
                                                                                                                    className={'self_arrow_trans'}/>
                                                                                                                <div
                                                                                                                    className={'im-link-title'}>
                                                                                                                    {item.msgData.title}
                                                                                                                </div>
                                                                                                                <div
                                                                                                                    className={'im-link-mid'}>
                                                                                                                    <div
                                                                                                                        className={'im-link-text'}>
                                                                                                                        {item.msgData.des}
                                                                                                                    </div>
                                                                                                                    <img
                                                                                                                        src={item.msgData.thumburl}/>
                                                                                                                </div>
                                                                                                                {/*{*/}
                                                                                                                {/*    item.loading != undefined ?*/}
                                                                                                                {/*        <img*/}
                                                                                                                {/*            src={imLoading}*/}
                                                                                                                {/*            className={'self_loading'}/> : ''*/}
                                                                                                                {/*}*/}
                                                                                                            </a>
                                                                                                        </div>
                                                                                                    </RightClick>
                                                                                                </SingleMsg> :
                                                                                                item.msgType == 29 ?
                                                                                                    <SingleMsg
                                                                                                        item={item}
                                                                                                        wxid={wxid}
                                                                                                        pageNum={pageNum}
                                                                                                    >
                                                                                                        <RightClick
                                                                                                            menuId={"rightClick" + index}
                                                                                                            item={this.getItems(item, index)}
                                                                                                        >
                                                                                                            <div
                                                                                                                className={'im-common'}>
                                                                                                                <Image
                                                                                                                    preview={item.msgData.gif_url}
                                                                                                                    src={item.msgData.gif_url}
                                                                                                                    className={'im-img'}/>
                                                                                                            </div>
                                                                                                        </RightClick>
                                                                                                    </SingleMsg> :
                                                                                                    item.msgType == 26 ?
                                                                                                        <SingleMsg
                                                                                                            item={item}
                                                                                                            wxid={wxid}
                                                                                                            pageNum={pageNum}
                                                                                                        >
                                                                                                            <RightClick
                                                                                                                menuId={"rightClick" + index}
                                                                                                                item={this.getItems(item, index)}
                                                                                                            >
                                                                                                                <div
                                                                                                                    className={'im-common'}>
                                                                                                                    <div
                                                                                                                        className={'im-redBag-max'}>
                                                                                                                        <img
                                                                                                                            src={red_arrow}
                                                                                                                            className={'self_arrow_trans'}/>
                                                                                                                        <div
                                                                                                                            className={'im-red-topMax'}>
                                                                                                                            <img
                                                                                                                                src={redBag}/>
                                                                                                                            <div>
                                                                                                                                <div
                                                                                                                                    className={'im-red-name'}>{item.msgData.des}</div>
                                                                                                                                <div
                                                                                                                                    className={'im-red-money'}>￥{Util.centTransformOut(item.msgData.money)}</div>
                                                                                                                            </div>
                                                                                                                        </div>
                                                                                                                        <Divider
                                                                                                                            className={'im-red-divider'}/>
                                                                                                                        <span
                                                                                                                            className={'im-red-bottom'}>{'红包'}
                                                                                                                    </span>
                                                                                                                    </div>
                                                                                                                </div>
                                                                                                            </RightClick>
                                                                                                        </SingleMsg> :
                                                                                                        item.msgType == 141 ?
                                                                                                            <SingleMsg
                                                                                                                item={item}
                                                                                                                wxid={wxid}
                                                                                                                pageNum={pageNum}
                                                                                                            >
                                                                                                                <RightClick
                                                                                                                    menuId={"rightClick" + index}
                                                                                                                    item={this.getItems(item, index)}
                                                                                                                >
                                                                                                                    <div
                                                                                                                        className={'im-common'}>
                                                                                                                        <div
                                                                                                                            className={'im-videoHao-max'}>
                                                                                                                            {/*<img*/}
                                                                                                                            {/*    src={white_arrow}*/}
                                                                                                                            {/*    className={'self_arrow_trans'}/>*/}
                                                                                                                            <div
                                                                                                                                className={'im-video-bg'}
                                                                                                                                style={{backgroundImage: `url(${item.msgData.thumb_url})`}}>
                                                                                                                            </div>
                                                                                                                            {/*<img*/}
                                                                                                                            {/*    className={'im-videoHao-top'}*/}
                                                                                                                            {/*    src={item.msgData.thumb_url}/>*/}
                                                                                                                            <div
                                                                                                                                className={'im-videoHao-mid'}>
                                                                                                                                <img
                                                                                                                                    src={item.msgData.head_img_url}/>
                                                                                                                                <span>{item.msgData.username}</span>
                                                                                                                            </div>
                                                                                                                            <div
                                                                                                                                className={'im-videoHao-desc'}>{item.msgData.channel_name}</div>
                                                                                                                            <div
                                                                                                                                className={'im-videoHao-divider'}>
                                                                                                                                <Divider/>
                                                                                                                            </div>
                                                                                                                            <div
                                                                                                                                className={'im-videoHao-bottom'}>
                                                                                                                                <img
                                                                                                                                    src={videoHao}/>
                                                                                                                                <span>{'视频号'}</span>
                                                                                                                            </div>
                                                                                                                        </div>
                                                                                                                    </div>
                                                                                                                </RightClick>
                                                                                                            </SingleMsg> :
                                                                                                            item.msgType == 4 ?
                                                                                                                <SingleMsg
                                                                                                                    item={item}
                                                                                                                    wxid={wxid}
                                                                                                                    pageNum={pageNum}
                                                                                                                >
                                                                                                                    <RightClick
                                                                                                                        menuId={"rightClick" + index}
                                                                                                                        item={this.getItems(item, index)}
                                                                                                                    >
                                                                                                                        <div
                                                                                                                            className={'im-common'}>
                                                                                                                            <div
                                                                                                                                className={'im-record-max'}>
                                                                                                                                <img
                                                                                                                                    src={white_arrow}
                                                                                                                                    className={'self_arrow_trans'}/>
                                                                                                                                <div
                                                                                                                                    className={'im-record-top'}>
                                                                                                                                    <img
                                                                                                                                        src={msgRecord}/>
                                                                                                                                    <span>{'聊天记录'}</span>
                                                                                                                                </div>
                                                                                                                                <Divider
                                                                                                                                    className={'im-record-divider'}/>
                                                                                                                                <span
                                                                                                                                    className={'im-record-bottom'}>{'请进入手机版企业微信查看'}</span>
                                                                                                                            </div>
                                                                                                                        </div>
                                                                                                                    </RightClick>
                                                                                                                </SingleMsg> :
                                                                                                                item.msgType == 123 ?
                                                                                                                    <div
                                                                                                                        className={'im-msg im-common'}
                                                                                                                        id={'im-msg-copy-value' + index}>
                                                                                                                        <TextWithImg
                                                                                                                            data={item.msgData.msg_list}
                                                                                                                            msg_unique_identifier={item.msgData.msg_unique_identifier}
                                                                                                                            wxid={wxid}/>
                                                                                                                        <img
                                                                                                                            src={blue_arrow}
                                                                                                                            className={'self_arrow'}/>
                                                                                                                    </div> : ''

                                                            }
                                                        </div>
                                                        {/*自己头图*/}
                                                        <img src={chatDataSelf.avatar}
                                                             className={'sender_headImg_self'}
                                                             style={{display: this.getDisplayValue(item)}}/>
                                                    </div>
                                                </div>
                                            </>
                                            :
                                            <>
                                                <div className={'message_content'}>
                                                    <div className={'im-info'}>
                                                        {/*对方头图*/}
                                                        {
                                                            //是群聊,并且在线
                                                            item.senderName && leftSelect.lineStatus == 1 ?
                                                                <Popover
                                                                    content={
                                                                        <AvatarInfo item={item} wxid={wxid}
                                                                                    chatWxIdKey={'senderId'}
                                                                        />
                                                                    }
                                                                    title=""
                                                                    zIndex={800} //modal的是1000， Popover默认1030
                                                                    trigger="click" placement="rightTop"
                                                                    overlayClassName={'zk-chatInfo-max'}
                                                                >
                                                                    <Dropdown trigger={['contextMenu']}
                                                                              onVisibleChange={value => this.onVisibleChangeForDropdown(value, item)}
                                                                              overlayClassName={'zk-overlay-item'}
                                                                              overlay={overlay}
                                                                    >
                                                                        <img key={item.msgId}
                                                                             src={item.sendAvator || chatData.avatar}
                                                                             className={'sender_headImg'}
                                                                             style={{display: this.getDisplayValue(item)}}/>
                                                                    </Dropdown>
                                                                </Popover> :
                                                                <img key={item.msgId}
                                                                     src={item.sendAvator || chatData.avatar}
                                                                     className={'sender_headImg'}
                                                                     style={{display: this.getDisplayValue(item)}}/>
                                                        }
                                                        <div className={'other-time-in-room'}>
                                                            {
                                                                //是否群聊
                                                                item.senderName ?
                                                                    <div className={'im-title'}
                                                                         style={{display: this.getDisplayValue(item)}}>
                                                                        <span
                                                                            className={'title-text'}>{item.senderName}</span>
                                                                        <div
                                                                            className={item.corpShortName == '微信' ? 'title-wxName' : 'title-corpName'}>{item.corpShortName ? `@${item.corpShortName}` : ''}</div>
                                                                        {/*<span*/}
                                                                        {/*    className={'title-time'}>{new Date(item.msgTime).format('yyyy-MM-dd hh:mm:ss')}</span>*/}
                                                                    </div> : ''
                                                            }
                                                            {
                                                                item.msgType == 2 || item.msgType == 0 ?
                                                                    <SingleMsg item={item} wxid={wxid}>
                                                                        <RightClick menuId={"rightClick" + index}
                                                                                    item={this.getItems(item, index)}
                                                                        >
                                                                            <div
                                                                                className={'im-msg-not-self im-common'}
                                                                                id={'im-msg-copy-value' + index}>
                                                                                <div
                                                                                    dangerouslySetInnerHTML={{__html: item.msgData.content}}/>
                                                                                <img src={white_arrow}
                                                                                     className={'not_self_arrow'}/>
                                                                            </div>
                                                                        </RightClick>
                                                                    </SingleMsg> :
                                                                    item.msgType == 16 ?
                                                                        <RightClick
                                                                            menuId={"rightClick" + index}
                                                                            item={this.getItems(item, index)}
                                                                        >
                                                                            <div>
                                                                                <SingleMsg item={item} wxid={wxid}
                                                                                           notSelf
                                                                                           updateScroll={this.updateScroll}
                                                                                           audioLoading={audioLoading}
                                                                                           pageNum={pageNum}>
                                                                                </SingleMsg>
                                                                            </div>
                                                                        </RightClick> :
                                                                        item.msgType == 14 || item.msgType == 101 ?
                                                                            <RightClick
                                                                                menuId={"rightClick" + index}
                                                                                item={this.getItems(item, index)}
                                                                            >
                                                                                <div>
                                                                                    <SingleMsg item={item}
                                                                                               wxid={wxid}
                                                                                               pageNum={pageNum}
                                                                                               getFileUrlList={this.getFileUrlList}
                                                                                               index={index}
                                                                                               updateScroll={this.updateScroll}>
                                                                                    </SingleMsg>
                                                                                </div>
                                                                            </RightClick> :
                                                                            item.msgType == 23 || item.msgType == 103 ?
                                                                                <RightClick
                                                                                    menuId={"rightClick" + index}
                                                                                    item={this.getItems(item, index)}
                                                                                >
                                                                                    <div>
                                                                                        <SingleMsg item={item}
                                                                                                   wxid={wxid}
                                                                                                   pageNum={pageNum}
                                                                                                   getFileUrlList={this.getFileUrlList}
                                                                                                   index={index}
                                                                                                   updateScroll={this.updateScroll}>

                                                                                        </SingleMsg>
                                                                                    </div>
                                                                                </RightClick> :
                                                                                item.msgType == 15 || item.msgType == 102 ?
                                                                                    <RightClick
                                                                                        menuId={"rightClick" + index}
                                                                                        item={this.getItems(item, index)}
                                                                                    >
                                                                                        <div>
                                                                                            <SingleMsg item={item}
                                                                                                       wxid={wxid}
                                                                                                       updateScroll={this.updateScroll}
                                                                                                       notSelf
                                                                                                       getFileUrlList={this.getFileUrlList}
                                                                                                       index={index}
                                                                                                       pageNum={pageNum}>
                                                                                            </SingleMsg>
                                                                                        </div>
                                                                                    </RightClick> :
                                                                                    item.msgType == 41 ?
                                                                                        <SingleMsg item={item}
                                                                                                   pageNum={pageNum}
                                                                                                   wxid={wxid}>
                                                                                            <RightClick
                                                                                                menuId={"rightClick" + index}
                                                                                                item={this.getItems(item, index)}
                                                                                            >
                                                                                                <div
                                                                                                    className={'im-common'}>
                                                                                                    <div
                                                                                                        className={'im-wxInfo'}>
                                                                                                        <img
                                                                                                            src={white_arrow}
                                                                                                            className={'not_self_arrow'}/>
                                                                                                        <div
                                                                                                            className={'wxInfo-header'}>
                                                                                                            <img
                                                                                                                src={item.msgData.headimg}/>
                                                                                                            <div>{item.msgData.nick}</div>
                                                                                                        </div>
                                                                                                        <div
                                                                                                            className={'wxInfo-line'}></div>
                                                                                                        <div
                                                                                                            className={'im-wxcard'}>{'个人名片'}</div>
                                                                                                    </div>
                                                                                                </div>
                                                                                            </RightClick>
                                                                                        </SingleMsg> :
                                                                                        item.msgType == 78 ?
                                                                                            <SingleMsg item={item}
                                                                                                       wxid={wxid}>
                                                                                                <RightClick
                                                                                                    menuId={"rightClick" + index}
                                                                                                    item={this.getItems(item, index)}
                                                                                                >
                                                                                                    <div
                                                                                                        className={'im-common'}>
                                                                                                        <div
                                                                                                            className={'im-wxapp'}>
                                                                                                            <img
                                                                                                                src={white_arrow}
                                                                                                                className={'not_self_arrow'}/>
                                                                                                            <div
                                                                                                                className={'wxapp-header'}>
                                                                                                                <img
                                                                                                                    src={item.msgData.headimg}/>
                                                                                                                <div>{item.msgData.title}</div>
                                                                                                            </div>
                                                                                                            <span
                                                                                                                className={'wxapp-desc'}>
                                                                                                {item.msgData.des}
                                                                                                    </span>
                                                                                                            {/*<img*/}
                                                                                                            {/*    src={item.msgData.coverImgUrl}*/}
                                                                                                            {/*    className={'wxapp-big-img'}/>*/}
                                                                                                            <div
                                                                                                                className={'wx-app-bg'}
                                                                                                                style={{backgroundImage: `url(${item.msgData.coverImgUrl || item.msgData.coverimgurl})`}}>
                                                                                                            </div>
                                                                                                            <div
                                                                                                                className={'wxInfo-line'}></div>
                                                                                                            <div
                                                                                                                className={'wxapp-bottom'}>
                                                                                                                <img
                                                                                                                    src={wxappLink}/>
                                                                                                                <div
                                                                                                                    className={'im-wxcard'}>{'小程序'}</div>
                                                                                                            </div>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                </RightClick>
                                                                                            </SingleMsg> :
                                                                                            item.msgType == 13 ?
                                                                                                <SingleMsg
                                                                                                    pageNum={pageNum}
                                                                                                    item={item}
                                                                                                    wxid={wxid}>
                                                                                                    <RightClick
                                                                                                        menuId={"rightClick" + index}
                                                                                                        item={this.getItems(item, index)}
                                                                                                    >
                                                                                                        <div
                                                                                                            className={'im-common'}>
                                                                                                            <a href={item.msgData.url}
                                                                                                               target={'_blank'}
                                                                                                               className={'im-msg-link'}>
                                                                                                                <img
                                                                                                                    src={white_arrow}
                                                                                                                    className={'not_self_arrow'}/>
                                                                                                                <div
                                                                                                                    className={'im-link-title'}>
                                                                                                                    {item.msgData.title}
                                                                                                                </div>
                                                                                                                <div
                                                                                                                    className={'im-link-mid'}>
                                                                                                                    <div
                                                                                                                        className={'im-link-text'}>
                                                                                                                        {item.msgData.des}
                                                                                                                    </div>
                                                                                                                    <img
                                                                                                                        src={item.msgData.thumburl}/>
                                                                                                                </div>
                                                                                                                {/*<div*/}
                                                                                                                {/*    className={'wxInfo-line'}></div>*/}
                                                                                                                {/*<div*/}
                                                                                                                {/*    className={'im-wxcard'}>{'百度一下'}</div>*/}
                                                                                                            </a>
                                                                                                        </div>
                                                                                                    </RightClick>
                                                                                                </SingleMsg> :
                                                                                                item.msgType == 29 ?
                                                                                                    <SingleMsg
                                                                                                        item={item}
                                                                                                        wxid={wxid}
                                                                                                        pageNum={pageNum}
                                                                                                    >
                                                                                                        <RightClick
                                                                                                            menuId={"rightClick" + index}
                                                                                                            item={this.getItems(item, index)}
                                                                                                        >
                                                                                                            <div
                                                                                                                className={'im-common'}>
                                                                                                                <Image
                                                                                                                    preview={item.msgData.gif_url}
                                                                                                                    src={item.msgData.gif_url}
                                                                                                                    className={'im-img'}/>
                                                                                                            </div>
                                                                                                        </RightClick>
                                                                                                    </SingleMsg> :
                                                                                                    item.msgType == 26 ?
                                                                                                        <SingleMsg
                                                                                                            pageNum={pageNum}
                                                                                                            item={item}
                                                                                                            wxid={wxid}
                                                                                                        >
                                                                                                            <RightClick
                                                                                                                menuId={"rightClick" + index}
                                                                                                                item={this.getItems(item, index)}
                                                                                                            >
                                                                                                                <div
                                                                                                                    className={'im-common'}>
                                                                                                                    <div
                                                                                                                        className={'im-redBag-max'}>
                                                                                                                        <img
                                                                                                                            src={red_arrow}
                                                                                                                            className={'not_self_arrow'}/>
                                                                                                                        <div
                                                                                                                            className={'im-red-topMax'}>
                                                                                                                            <img
                                                                                                                                src={redBag}/>
                                                                                                                            <div>
                                                                                                                                <div
                                                                                                                                    className={'im-red-name'}>{item.msgData.des}</div>
                                                                                                                                <div
                                                                                                                                    className={'im-red-money'}>￥{Util.centTransformOut(item.msgData.money)}</div>
                                                                                                                            </div>
                                                                                                                        </div>
                                                                                                                        <Divider
                                                                                                                            className={'im-red-divider'}/>
                                                                                                                        <span
                                                                                                                            className={'im-red-bottom'}>{'红包'}
                                                                                                                    </span>
                                                                                                                    </div>
                                                                                                                </div>
                                                                                                            </RightClick>
                                                                                                        </SingleMsg> :
                                                                                                        item.msgType == 141 ?
                                                                                                            <SingleMsg
                                                                                                                item={item}
                                                                                                                wxid={wxid}
                                                                                                                pageNum={pageNum}
                                                                                                            >
                                                                                                                <RightClick
                                                                                                                    menuId={"rightClick" + index}
                                                                                                                    item={this.getItems(item, index)}
                                                                                                                >
                                                                                                                    <div
                                                                                                                        className={'im-common'}>
                                                                                                                        <div
                                                                                                                            className={'im-videoHao-max'}>
                                                                                                                            {/*<img*/}
                                                                                                                            {/*    src={white_arrow}*/}
                                                                                                                            {/*    className={'not_self_arrow'}/>*/}
                                                                                                                            <div
                                                                                                                                className={'im-video-bg'}
                                                                                                                                style={{backgroundImage: `url(${item.msgData.thumb_url})`}}>
                                                                                                                            </div>
                                                                                                                            {/*<img*/}
                                                                                                                            {/*    className={'im-videoHao-top'}*/}
                                                                                                                            {/*    src={item.msgData.thumb_url}/>*/}
                                                                                                                            <div
                                                                                                                                className={'im-videoHao-mid'}>
                                                                                                                                <img
                                                                                                                                    src={item.msgData.head_img_url}/>
                                                                                                                                <span>{item.msgData.username}</span>
                                                                                                                            </div>
                                                                                                                            <div
                                                                                                                                className={'im-videoHao-desc'}>{item.msgData.channel_name}</div>
                                                                                                                            <div
                                                                                                                                className={'im-videoHao-divider'}>
                                                                                                                                <Divider/>
                                                                                                                            </div>
                                                                                                                            <div
                                                                                                                                className={'im-videoHao-bottom'}>
                                                                                                                                <img
                                                                                                                                    src={videoHao}/>
                                                                                                                                <span>{'视频号'}</span>
                                                                                                                            </div>
                                                                                                                        </div>
                                                                                                                    </div>
                                                                                                                </RightClick>
                                                                                                            </SingleMsg> :
                                                                                                            item.msgType == 4 ?
                                                                                                                <SingleMsg
                                                                                                                    item={item}
                                                                                                                    wxid={wxid}
                                                                                                                    pageNum={pageNum}
                                                                                                                >
                                                                                                                    <RightClick
                                                                                                                        menuId={"rightClick" + index}
                                                                                                                        item={this.getItems(item, index)}
                                                                                                                    >
                                                                                                                        <div
                                                                                                                            className={'im-common'}>
                                                                                                                            <div
                                                                                                                                className={'im-record-max'}>
                                                                                                                                <img
                                                                                                                                    src={white_arrow}
                                                                                                                                    className={'not_self_arrow'}/>
                                                                                                                                <div
                                                                                                                                    className={'im-record-top'}>
                                                                                                                                    <img
                                                                                                                                        src={msgRecord}/>
                                                                                                                                    <span>{'聊天记录'}</span>
                                                                                                                                </div>
                                                                                                                                <Divider
                                                                                                                                    className={'im-record-divider'}/>
                                                                                                                                <span
                                                                                                                                    className={'im-record-bottom'}>{'请进入手机版企业微信查看'}</span>
                                                                                                                            </div>
                                                                                                                        </div>
                                                                                                                    </RightClick>
                                                                                                                </SingleMsg> :
                                                                                                                item.msgType == 123 ?
                                                                                                                    <div
                                                                                                                        className={'im-msg-not-self im-common'}
                                                                                                                        id={'im-msg-copy-value' + index}>
                                                                                                                        <TextWithImg
                                                                                                                            data={item.msgData.msg_list}
                                                                                                                            msg_unique_identifier={item.msgData.msg_unique_identifier}
                                                                                                                            wxid={wxid}/>
                                                                                                                        <img
                                                                                                                            src={white_arrow}
                                                                                                                            className={'not_self_arrow'}/>
                                                                                                                    </div> : ''
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                    }
                                </div>
                            </div>
                        </List.Item>
                    )}
                />

                {/*{添加到素材库modal}*/}
                <ZkModal title={'添加到素材库'} className={'modal-right-btn im-setting-modal zk-pro-padding'}
                         ref={r => this.materialRef = r} width={'518px'} onOk={this.doAddMaterialApi} destroyOnClose
                         okButtonProps={{disabled: matrialTitle == ''}}
                         maskClosable={false}
                >
                    <ZkFormItem title={'素材标题'} titleWidth={'80px'} colon={true} conWidth={320} required>
                        <Input placeholder="请输入素材标题"
                               onChange={e => {
                                   let value = e.target.value
                                   this.setState({
                                       matrialTitle: value
                                   })
                               }}/>
                    </ZkFormItem>
                    <ZkFormItem title={'素材分组'} titleWidth={'80px'} colon={true} conWidth={320}>
                        <Select
                            ref={r => this.matrialSelect = r}
                            onChange={value => {
                                this.setState({
                                    materialId: value
                                })
                            }}
                            showSearch
                            style={{
                                width: 320,
                            }}
                            placeholder="请选择分组"
                            optionFilterProp="children"
                            filterOption={(input, option) => option.children.includes(input)}
                            filterSort={(optionA, optionB) =>
                                optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
                            }
                        >
                            {
                                materialList.map((item, index) => {
                                    return (
                                        <Option value={item.groupId}>{item.groupName}</Option>
                                    )
                                })
                            }
                        </Select>
                    </ZkFormItem>
                </ZkModal>

                {/*{已经是好友提示 modal}*/}
                <ZkModal title={'温馨提示'} className={'modal-right-btn im-setting-modal'}
                         closable={false} width={450}
                         maskClosable={false}
                         ref={r => this.alreadyBeFriendRef = r}
                         footer={
                             <Button type={'primary'} onClick={() => this.alreadyBeFriendRef.hide()}>
                                 {'知道了'}
                             </Button>
                         }
                >
                    {'对方已经是您的好友了！无需添加。'}
                </ZkModal>

                {/*{群聊中添加好友modal}*/}
                <ZkModal title={'添加好友'} className={'modal-right-btn im-setting-modal'}
                         ref={r => this.friendRoomRef = r} width={600} onOk={this.doAddFriendFromRoomApi} destroyOnClose
                         confirmLoading={addFriendLoading}
                         afterClose={() => {
                             this.setState({
                                 addFriendLoading: false
                             })
                         }}
                         maskClosable={false}
                >
                    <ZkFormItem title={'验证信息'} colon={true} conWidth={470}>
                        <TextArea
                            value={addInfo}
                            onChange={this.addUserChange}
                            autoSize={{minRows: 6, maxRows: 6}}
                        />
                    </ZkFormItem>
                </ZkModal>

                {/*{加好友请求modal}*/}
                <ZkModal title={'发送联系人验证'} className={'modal-right-btn im-setting-modal'}
                         ref={r => this.addUserRef = r} width={600} onOk={this.addFriendApi} destroyOnClose
                         maskClosable={false}
                >
                    <ZkFormItem title={'验证信息'} colon={true} conWidth={470}>
                        <TextArea
                            value={addInfo}
                            onChange={this.addUserChange}
                            autoSize={{minRows: 6, maxRows: 6}}
                        />
                    </ZkFormItem>
                </ZkModal>

                {/*{名片添加好友modal}*/}
                <ZkModal title={'添加好友'} className={'modal-right-btn im-setting-modal'}
                         ref={r => this.friendCardRef = r} width={600} onOk={this.doAddFriendFromCardApi} destroyOnClose
                         maskClosable={false}
                >
                    <ZkFormItem title={'验证信息'} colon={true} conWidth={470}>
                        <TextArea
                            value={addInfo}
                            onChange={this.addUserChange}
                            autoSize={{minRows: 6, maxRows: 6}}
                        />
                    </ZkFormItem>
                </ZkModal>

                {/*{踢人modal}*/}
                <ZkModal title={'踢人确认'} ref={r => this.deleteModalRef = r} width={420} closable={false}
                         className={'modal-right-btn'}
                         footer={[
                             <Button key="back" onClick={() => this.deleteModalRef.hide()}>
                                 取消
                             </Button>,
                             <Button key="ok" type="primary" loading={delLoading} onClick={this.delApi}>
                                 踢出
                             </Button>,
                             <Button key="submit" type="primary" loading={blackLoading}
                                     onClick={this.delAndBlackApi}>
                                 踢出并加入黑名单
                             </Button>,
                         ]}
                >
                    <div className={'modal-tip-content'}>
                        <img src={modal_warning}/>
                        <div>提示</div>
                    </div>
                    <div className={'send-modal-text'}>
                        {`确定要从群聊【${chatData.name}】踢走【${delData.senderName}】？（请确保群主已登录企微助手Pro，且当前操作的企微号为群主、管理账号，否则无法踢人！）`}
                    </div>
                </ZkModal>

                {/* 转发modal*/}
                <ZkModal
                    title={'选择聊天'}
                    className={'modal-right-btn im-setting-modal'}
                    ref={r => this.forwardModalRef = r}
                    width={'688px'}
                    destroyOnClose
                    maskClosable={false}
                    afterClose={this.afterClose}
                    footer={[
                        <Button key="back" onClick={() => {
                            this.forwardModalRef.hide()
                        }}>
                            取消
                        </Button>,
                        <Button key="submit" type="primary"
                                disabled={!isForward}
                                onClick={this.sendMore}>
                            转发
                        </Button>,
                    ]}
                >
                    <ImForward ref={r => this.imForwardRef = r} wxid={wxid} getStatus={this.getStatus}/>
                </ZkModal>
            </>
        );
    }
}

export default MessageListClass;